export const menu = [
    {
        "type": 'header',
        "label": 'Pagine'
    },
    {
        "type": 'item',
        "href": '/',
        "icon": 'home',
        "entity": '',
        "label": 'Homepage'
    },
    {
        "type": 'item',
        "href": '/entity/gyv_voyage',
        "icon": 'truck',
        "entity": 'voyage',
        "label": 'Viaggi'
    },
    {
        "type": 'item',
        "href": '/page/ErrorVoyage',
        "icon": 'triangle-exclamation',
        "entity": 'voyage',
        "label": 'Viaggi incompleti'
    },
    {
        "type": 'item',
        "href": '/page/DoubleVoyage',
        "icon": 'truck-plane',
        "entity": 'voyage',
        "label": 'Viaggi duplicati'
    },
/*     {
        "type": 'item',
        "href": '/entity/gyv_voyage_double',
        "icon": 'truck-plane',
        "entity": 'voyage',
        "label": 'Viaggi duplicati'
    }, */
    {
        "type": 'item',
        "href": '/entity/terminal',
        "icon": 'road',
        "entity": 'terminal',
        "label": 'Terminal'
    },
    /*
    {
        "type": 'item',
        "href": '/entity/receipt_sender',
        "icon": 'envelope',
        "entity": 'receipt_sender',
        "label": 'Mittenti fattura'
    },
    */
    {
        "type": 'item',
        "href": '/entity/transitario',
        "icon": 'users',
        "entity": 'transitario',
        "label": 'Transitari'
    },
    {
        "type": 'item',
        "href": '/page/ImportaTreni',
        "icon": 'train',
        "entity": 'voyage',
        "label": 'Importa treni'
    },

    {
        "type": 'divider'
    },
    {
        "type": 'item',
        "href": '/page/EsportaViaggi',
        "icon": 'download',
        "entity": 'voyage',
        "label": 'Esporta viaggi'
    },
    {
        "type": 'item',
        "href": '/page/Estrazione',
        "icon": 'chart-simple',
        "entity": 'receipt',
        "label": 'Fatturazione viaggi'
    },
    {
        "type": 'item',
        "href": '/entity/receipt',
        "icon": 'file-invoice',
        "entity": 'receipt',
        "label": 'Storico esportazioni'
    },
    {
        "type": 'item',
        "href": '/page/Stats',
        "icon": 'chart-line',
        "entity": 'receipt',
        "label": 'Report'
    },
    {
        "type": 'item',
        "href": '/page/Analisi',
        "icon": 'chart-pie',
        "entity": 'receipt',
        "label": 'Analisi'
    },
    {
        "type": 'item',
        "href": '/page/ImportaViaggi',
        "icon": 'file-import',
        "entity": 'voyage',
        "label": 'Importa viaggi xml'
    },
    {
        "type": 'item',
        "href": '/page/UploadExcel',
        "icon": 'file-excel',
        "entity": 'receipt',
        "label": 'Importa csv'
    },
    {
        "type": 'item',
        "href": '/entity/import_history',
        "icon": 'clock',
        "entity": 'import_history',
        "label": 'Storico importazioni'
    },

    {
        "type": 'header',
        "label": 'Utente'
    },
    {
        "type": 'item',
        "href": '/settings',
        "icon": 'user-gear',
        "entity": '',
        "label": 'Profilo'
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'cogs',
        "entity": '',
        "label": 'Impostazioni',
        "items": [
            {
                "type": 'item',
                "href": '/entity/user',
                "entity": 'user',
                "label": 'Utenti'
            },
            {
                "type": 'item',
                "href": '/entity/user_group',
                "entity": 'user_group',
                "label": 'Gruppi'
            },
            {
                "type": 'item',
                "href": '/entity/operatore_di_varco',
                "icon": 'receipt',
                "entity": 'operatore_di_varco',
                "label": 'Operatori di varco'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_saved_filters',
                "entity": 'user_entity_saved_filters',
                "label": 'Filtri salvati'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_preferences',
                "entity": 'user_entity_preferences',
                "label": 'Preferenze entità'
            },
            {
                "type": 'item',
                "href": '/entity/log',
                "entity": 'log',
                "label": 'Log'
            },
        ]
    },
    {
        "type": 'item',
        "href": '/logout',
        "icon": 'arrow-right-from-bracket',
        "entity": '',
        "label": 'Logout'
    }
]